import type { MeResponse } from "../../shared/api.js";
import { BlazeMark } from "../components/Panel.js";

export function HomeScreen({
  me,
}: {
  me: MeResponse;
  onUpdate: (m: MeResponse) => void;
}) {
  return (
    <div className="flex flex-col gap-6">
      <section>
        <h1 className="font-display text-[28px] text-granite-900 dark:text-granite-50 mb-1">
          Bonjour, {me.user.displayName}
        </h1>
        <p className="font-text text-granite-600 dark:text-granite-300">
          {me.group.name}
        </p>
      </section>

      <section
        className="panel overflow-hidden"
        style={{
          backgroundImage:
            "linear-gradient(135deg, color-mix(in srgb, var(--color-glacier) 14%, transparent), transparent 60%)",
        }}
      >
        <div className="flex items-start justify-between">
          <div>
            <p className="font-text text-[13px] uppercase tracking-wider text-glacier dark:text-glacier-300 mb-2">
              Next session
            </p>
            <h2 className="font-display text-[22px] text-granite-900 dark:text-granite-50 mb-1">
              Checking into a refuge
            </h2>
            <p className="font-text text-[15px] text-granite-600 dark:text-granite-300">
              Order lunch and ask about trail conditions · About 12 minutes
            </p>
          </div>
          <BlazeMark solid className="mt-1 text-blaze" />
        </div>
        <div className="mt-4">
          <button
            type="button"
            className="min-h-[48px] px-5 inline-flex items-center gap-2 rounded-[var(--radius-control)] bg-blaze text-white font-text text-[17px] hover:bg-blaze-dim transition-colors"
          >
            Begin
          </button>
        </div>
      </section>

      <section className="flex flex-col gap-3">
        <p className="font-text text-[13px] uppercase tracking-wider text-granite-500 dark:text-granite-400">
          Household
        </p>
        <div className="panel divide-y divide-granite-100 dark:divide-granite-700">
          {me.group.members.map((m) => (
            <div key={m.userId} className="flex items-center justify-between py-3">
              <span className="font-text text-granite-800 dark:text-granite-100">
                {m.displayName}
              </span>
              <span className="font-text text-[13px] text-granite-500 dark:text-granite-400">
                {m.role === "owner" ? "Organiser" : "Member"}
              </span>
            </div>
          ))}
        </div>
      </section>

      <section className="panel p-4">
        <h3 className="font-text font-semibold text-[17px] text-granite-800 dark:text-granite-100 mb-1">
          Install on this phone
        </h3>
        <p className="font-text text-[15px] text-granite-600 dark:text-granite-300 leading-relaxed">
          On the home screen, choose “Add to Home Screen”. lingoLoco works
          offline for the trek once you have signed in.
        </p>
      </section>
    </div>
  );
}
